import { render, staticRenderFns } from "./NameStatusAmendment.vue?vue&type=template&id=923ed0f2"
import script from "./NameStatusAmendment.vue?vue&type=script&lang=js"
export * from "./NameStatusAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports